import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { actions as uiActions } from 'state/ui';

import ModalFaqs from 'components/ModalFaqs/component';

const enhance = compose(
  withTranslation('Faqs'),
  connect(() => {}, {
    toggleModalFaqs: uiActions.toggleModalFaqs,
  }),
  withHandlers(() => ({
    handleClose:
      ({ toggleModalFaqs }) =>
      () => {
        toggleModalFaqs({ order: false });
      },
  }))
);

export default enhance(ModalFaqs);
